module.exports = __webpack_public_path__ + "static/media/ic_workers_no_results.0f8f56ab.svg";